import React from 'react';
import '../../styles/FileManager.css';
import TableForFilesManager from './TableForFilesManager';

/**
 * Компонент `FileManager` представляет файловый менеджер, отображающий таблицу файлов.
 * Включает в себя компонент `TableForFilesManager`, который обрабатывает данные о файлах и папках.
 *
 * @component
 * @example
 * return <FileManager />;
 *
 * @returns {JSX.Element} - Компонент файлового менеджера.
 */
function FileManager() {
  return (
    <div className="files margin-left-10">
      <div className="files-content">
        {/* Основной компонент таблицы файлового менеджера */}
        <TableForFilesManager />
      </div>
    </div>
  );
}

export default FileManager;
